import {isNotNilOrEmpty} from 'ramda-adjunct';

import {LocalizedContentValues} from '../types/GeneralSettingsFormValues';

export function hasLocalizedContent(entry: LocalizedContentValues): boolean {
  return (
    isNotNilOrEmpty(entry.titleExtension) ||
    isNotNilOrEmpty(entry.subtitle) ||
    isNotNilOrEmpty(entry.description)
  );
}
